import React from 'react';
import { useNavigate } from 'react-router-dom';

const TrialExpiredOverlay = ({ onClose }) => {
  const navigate = useNavigate();

  const handleUpgrade = () => {
    navigate('/admin/plans');
  };

  const handleDebugPanel = () => {
    // Cerrar overlay y navegar al dashboard con modo debug activado
    onClose();
    navigate('/admin/dashboard?debug=true');
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.8)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 10000
    }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: '20px',
        padding: '40px',
        maxWidth: '500px',
        width: '90%',
        textAlign: 'center',
        boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)'
      }}>
        <div style={{ fontSize: '4rem', marginBottom: '20px' }}>⏰</div>
        
        <h2 style={{ 
          fontSize: '2rem', 
          marginBottom: '15px', 
          color: '#dc3545',
          fontWeight: 'bold'
        }}>
          Trial Expirado
        </h2>
        
        <p style={{ 
          fontSize: '1.1rem', 
          marginBottom: '30px', 
          color: '#666',
          lineHeight: '1.5'
        }}>
          Tu periodo de prueba gratuito de 14 días ha terminado. 
          Para continuar usando todas las funcionalidades de Aturno, 
          necesitas elegir un plan.
        </p>

        <div style={{
          backgroundColor: '#f8f9fa',
          padding: '20px',
          borderRadius: '10px',
          marginBottom: '30px'
        }}>
          <h3 style={{ 
            fontSize: '1.2rem', 
            marginBottom: '10px', 
            color: '#495057' 
          }}>
            Funcionalidades bloqueadas:
          </h3>
          <ul style={{ 
            textAlign: 'left', 
            color: '#6c757d',
            margin: '0',
            paddingLeft: '20px'
          }}>
            <li>Gestión de personal</li>
            <li>Creación de servicios</li>
            <li>Gestión de recursos</li>
            <li>Reservas de clientes</li>
            <li>Analytics y reportes</li>
          </ul>
        </div>

        <div style={{ display: 'flex', gap: '10px', justifyContent: 'center', flexWrap: 'wrap' }}>
          <button
            onClick={handleUpgrade}
            style={{
              backgroundColor: '#007bff',
              color: 'white',
              border: 'none',
              padding: '15px 30px',
              borderRadius: '10px',
              fontSize: '1.1rem',
              fontWeight: 'bold',
              cursor: 'pointer',
              transition: 'background-color 0.3s'
            }}
            onMouseOver={(e) => e.target.style.backgroundColor = '#0056b3'}
            onMouseOut={(e) => e.target.style.backgroundColor = '#007bff'}
          >
            🚀 Ver Planes
          </button>

          {/* Botón de debug solo en localhost */}
          {window.location.hostname === 'localhost' && (
            <button
              onClick={handleDebugPanel}
              style={{
                backgroundColor: '#28a745',
                color: 'white',
                border: 'none',
                padding: '15px 30px',
                borderRadius: '10px',
                fontSize: '1.1rem',
                fontWeight: 'bold',
                cursor: 'pointer',
                transition: 'background-color 0.3s'
              }}
              onMouseOver={(e) => e.target.style.backgroundColor = '#218838'}
              onMouseOut={(e) => e.target.style.backgroundColor = '#28a745'}
            >
              🧪 Debug Panel
            </button>
          )}
          
          <button
            onClick={onClose}
            style={{
              backgroundColor: 'transparent',
              color: '#6c757d',
              border: '2px solid #dee2e6',
              padding: '15px 30px',
              borderRadius: '10px',
              fontSize: '1.1rem',
              cursor: 'pointer',
              transition: 'all 0.3s'
            }}
            onMouseOver={(e) => {
              e.target.style.backgroundColor = '#f8f9fa';
              e.target.style.borderColor = '#adb5bd';
            }}
            onMouseOut={(e) => {
              e.target.style.backgroundColor = 'transparent';
              e.target.style.borderColor = '#dee2e6';
            }}
          >
            Cerrar
          </button>
        </div>

        <p style={{ 
          fontSize: '0.9rem', 
          color: '#adb5bd', 
          marginTop: '20px',
          fontStyle: 'italic'
        }}>
          ¿Tienes dudas? Contáctanos para más información sobre nuestros planes.
        </p>
      </div>
    </div>
  );
};

export default TrialExpiredOverlay;